<template>
  <div class="public-content platform-sku">
    <div class="breadcrumb">模板页</div>
    <div class="right-main">
      <!--      查询订单-->
      <el-form :inline="true" :model="searchTemplateVo" label-width="100px" class="demo-form-inline">
        <el-row>
          <el-col :span="5">
            <el-form-item label="页面类型:">
              <el-select clearable v-model="searchTemplateVo.pageTypeCode" placeholder="请选择">
                <el-option label="" value="">全部</el-option>
                <el-option v-for="item in $store.state.pms.pageTypeList" :key="item.id" :label="item.typeName" :value="item.typeCode"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="模板页性质:">
              <el-select clearable v-model="searchTemplateVo.propertyId" placeholder="请选择">
                <el-option label="" value="">全部</el-option>
                <el-option v-for="item in propertyList" :key="item.id" :label="item.propertyName" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="模板页主题:">
              <el-select v-model="searchTemplateVo.templateThemeId" clearable placeholder="请选择">
                <el-option label="" value="">全部</el-option>
                <el-option v-for="item in categoryList" :key="item.id" :label="item.themeName" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="图片数量:">
              <el-input v-model="searchTemplateVo.imageCount" clearable placeholder="请输入图片数量"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="宽高:">
              <el-input v-model="searchTemplateVo.templateSize" placeholder="请输入宽高" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="状态:">
              <el-select v-model="searchTemplateVo.auditStatus" clearable placeholder="请选择">
                <el-option label="" value="">全部</el-option>
                <el-option label="待审核" value="APPLY"></el-option>
                <el-option label="审核拒绝" value="REJECTED"></el-option>
                <el-option label="已审核" value="AUDITED"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="创建日期:">
              <el-date-picker v-model="value1" value-format="yyyy-MM-dd" format="yyyy-MM-dd" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                :picker-options="pickerOptions"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="5" class="fn-right form-btn">
            <el-button class="search-ok" @click="queryInfo.pageNum = 1, onSubmit()" round>查询</el-button>
            <el-button class="search-ok" v-permission="'pts:admin:template:group:audit'" @click="auditAll" round type="primary"> 批量审核</el-button>
          </el-col>
        </el-row>
      </el-form>
      <div class="data-list">
        <el-table :data="tableData" @selection-change="handleSelectionChange" border style="width: 100%">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="id" label="编号"></el-table-column>
          <!-- <el-table-column prop="associatedeNum" label="关联编号"></el-table-column> -->
          <el-table-column prop="templateThumbnail" label="模板页缩略图" min-width="200px">
            <template slot-scope="scope">
              <templateThumbnail :templateGroup="scope.row" />
              <!-- <div class="imgBox">
                <div class="img">
                  <el-image style="width:100%;height:100%;" :preview-src-list="scope.row.templateThumbnailList" v-if="scope.row.templateThumbnailList[0]"
                    :src="scope.row.templateThumbnailList[0]" fit="fill"></el-image>
                </div>
                <div class="img" v-if="scope.row.propertyId!==2">
                  <el-image style="width:100%;height:100%;" :preview-src-list="scope.row.templateThumbnailList" v-if="scope.row.templateThumbnailList[1]"
                    :src="scope.row.templateThumbnailList[1]" fit="fill"></el-image>
                </div>
              </div> -->
            </template>
          </el-table-column>
          <el-table-column prop="propertyName" label="页面类型">
            <template slot-scope="scope"> {{ $store.state.pms.pageType[scope.row.pageTypeCode] }} </template>
          </el-table-column>
          <el-table-column prop="propertyName" label="模板页性质">
            <template slot-scope="scope"> {{ propertyObj[scope.row.propertyId] }} </template>
          </el-table-column>
          <el-table-column prop="imageCount" label="照片数量"></el-table-column>
          <el-table-column prop="layoutNum" label="版式数量">
            <template slot-scope="scope"> {{ '已关联版式：' + scope.row.layoutNum }} </template>
          </el-table-column>
          <el-table-column prop="templateSize" label="宽高"></el-table-column>
          <el-table-column prop="createdName" label="设计人员"></el-table-column>
          <el-table-column prop="themeName" label="模板页主题"></el-table-column>
          <el-table-column prop="auditStatus" label="状态">
            <template slot-scope="scope"> {{ scope.row.auditStatus === 'AUDITED' ? '已审核' : scope.row.auditStatus === 'REJECTED' ? '已拒绝' : scope.row.auditStatus === 'APPLY' ? '待审核' : "未定义字段" }}
            </template>
          </el-table-column>
          <el-table-column prop="createdTime" label="创建日期"></el-table-column>
          <el-table-column prop="payDate" label="操作">
            <template slot-scope="scope">
              <span class="color-blue" v-if="scope.row.auditStatus === 'AUDITED' && $hasPermission('pts:admin:template:group:detail')" @click="check(scope.row, 'check')">查看<br></span>
              <span class="color-blue" v-if="scope.row.auditStatus === 'APPLY' && $hasPermission('pts:admin:template:group:audit')" @click="check(scope.row, 'audit')">审核<br></span>
              <span class="color-blue" @click="$refs.relationFormat.show(scope.row)">关联版式<br></span>
              <span class="color-blue" v-if="scope.row.auditStatus !== 'APPLY' && $hasPermission('pts:admin:template:group:batchRemove')"
                @click="deleteId = scope.row.id, deleteDialog = true">删除</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--    分页-->
      <v-pagination class="v-pagination" @changePage="changePage" :queryInfo='queryInfo'></v-pagination>
    </div>
    <!-- 删除确认 -->
    <el-dialog :close-on-click-modal="false" title="确认" :visible.sync="deleteDialog" width="30%">
      <span>确认删除该模板页？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteDialog = false">取 消</el-button>
        <el-button type="primary" @click="deleteTem(deleteId)">确 定</el-button>
      </span>
    </el-dialog>
    <relationFormat ref="relationFormat" @success="onSubmit"></relationFormat>
  </div>
</template>

<script>
import templateThumbnail from '@/components/templateThumbnail.vue'
import relationFormat from './relationFormat.vue'
import VPagination from '@/components/Pagination/index.vue'
import { templateGroupGetTemplateGroupList, templateGroupAuditTemplateGroup, sampleListNoPaging, propertyGetPropertyList, templateGroupBatchRemove, pageTypeList } from '@/api/pms'

export default {
  name: 'platform-sku',
  components: {
    VPagination, relationFormat, templateThumbnail
  },
  inject: ['reload'],
  data () {
    return {
      deleteId: '',
      deleteDialog: false,
      tableData: [],
      value1: [],
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now() - 8.64e6
        }
      },
      searchTemplateVo: {
        auditStatus: '',
        createTimeBegin: '',
        createTimeEnd: '',
        imageCount: '',
        page: 1,
        pageTypeCode: '',
        propertyId: '',
        templateSize: '',
        templateThemeId: ''
      },
      queryInfo: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      multipleSelection: [],
      categoryList: [],
      pageTypeList: [],
      propertyObj: {},
      propertyList: []
    }
  },
  watch: {
    value1 (val) {
      this.searchTemplateVo.createTimeBegin = val === null ? '' : val[0]
      this.searchTemplateVo.createTimeEnd = val === null ? '' : val[1]
    }
  },
  created () {
    if (sessionStorage.getItem('searchFlag') === 'true') {
      this.searchTemplateVo = JSON.parse(sessionStorage.getItem('queryParams'))
      this.queryInfo = JSON.parse(sessionStorage.getItem('queryInfo'))
      this.value1 = [this.searchTemplateVo.createTimeBegin, this.searchTemplateVo.createTimeEnd]
      sessionStorage.removeItem('searchFlag')
    } else {
      // 首次进入列表页,清除缓存中的搜索条件
      sessionStorage.removeItem('queryParams')
      sessionStorage.removeItem('queryInfo')
    }
    // this.getPageTypeList()
    this.getFormatList()
    this.getSampleListNoPaging()
    this.onSubmit()
    this.$store.dispatch('pms/getPageTypeList')
  },
  destroyed () {
    // 销毁
    console.log('页面销毁')
    sessionStorage.removeItem('searchFlag')
  },
  methods: {
    check (row, type) {
      sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
      sessionStorage.setItem('queryParams', JSON.stringify(this.searchTemplateVo))
      if (type === 'audit') this.$router.push({ path: '/checktemplate', query: { id: row.id, type: 'audit' } })
      if (type === 'check') this.$router.push({ path: '/checktemplate', query: { id: row.id, type: 'check' } })
    },
    getSampleListNoPaging () {
      sampleListNoPaging().then(res => {
        if (res.data.success) {
          this.categoryList = res.data.data
        }
      })
    },
    auditAll () {
      if (this.multipleSelection.length < 1) {
        this.$message.error('请选择待审核状态的模板页')
        return
      }
      let idList = []
      this.multipleSelection.forEach(item => {
        if (item.auditStatus === 'APPLY') {
          idList.push(item.id)
        }
      })
      if (idList.length !== this.multipleSelection.length) {
        this.$message.error('只可审核状态是待审核的模板页')
        return
      }
      templateGroupAuditTemplateGroup({ auditStatus: 'AUDITED', idList }).then(res => {
        if (res.data.success) {
          this.$message.success('审核成功')
          this.onSubmit()
        }
      })
    },
    deleteTem (id) {
      templateGroupBatchRemove([id]).then(res => {
        if (res.data.success) {
          this.$message.success('删除成功')
          this.onSubmit()
          this.deleteDialog = false
        }
      })
    },
    // 获取模板性质列表
    getFormatList () {
      propertyGetPropertyList().then(res => {
        if (res.data.success) {
          this.propertyObj = res.data.data.reduce((obj, item) => {
            obj[item.id] = item.propertyName
            return obj
          }, {})
          this.propertyList = res.data.data
        }
      })
    },
    // 获取页面类型
    // getPageTypeList () {
    //   pageTypeList().then(res => {
    //
    //     if (res.data.success) {
    //       this.pageTypeList = res.data.data
    //     }
    //   })
    // },
    onSubmit () {
      if (sessionStorage.getItem('searchFlag')) {
        sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
        sessionStorage.setItem('queryParams', JSON.stringify(this.searchTemplateVo))
      }
      templateGroupGetTemplateGroupList({ pageNum: this.queryInfo.pageNum, pageSize: this.queryInfo.pageSize, searchTemplateVo: this.searchTemplateVo }).then(res => {
        if (res.data.success) {
          if (res.data.data.records.length === 0 && res.data.data.total !== 0 && this.queryInfo.pageNum !== 1) {
            this.queryInfo.pageNum--
            this.onSubmit(this.queryInfo)
          }
          let obj = res.data.data.records

          // obj.forEach(item => {
          //   if (item.propertyId === 2) {
          //     item.templateThumbnailList = [item.templates[0].templateThumbnail]
          //   } else {
          //     item.templateThumbnailList = item.templates.reduce((list, temp) => {
          //       list[temp.templatePosition] = temp.templateThumbnail
          //       return list
          //     }, [])
          //   }
          // })

          this.tableData = obj
          console.log(obj)
          this.queryInfo.total = res.data.data.total
        }
      })
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    changePage (val) {
      this.queryInfo = val
      this.onSubmit()
    }
  }
}
</script>

<style scoped lang="less">
@import "index";

@deep: ~">>>";

.imgBox {
  width: 100%;
  display: flex;
  justify-content: space-around;

  .img {
    flex: 1;
    // border: 1px solid #000;
  }
}
</style>
